<!-- 由 suu 创建于 2025-09-23 星期二 -->
<template>
  <div
    class="coach-wxwork-card"
    ref="parentScroll"
    :style="{ paddingTop: isApp ? navBarContentHeight + 'px' : 0 }"
  >
    <!-- <CardlNavBar :opacity="navBarOpacity" @share="handleShare" /> -->
    <CardlNavBar
      :opacity="navBarOpacity"
      @share="handleShare"
      v-if="isApp"
      @getBottomContentHeight="getBottomContentHeight"
    />
    <img class="cwc-bg" v-if="imgUrl" :src="imgUrl" alt="" />
    <div class="cwc-container" ref="cwcContainer" v-else-if="curInfo">
      <div class="cwc-tips" v-if="showType != 'coach'">
        <van-icon class="tips-icon" name="warning" />
        <div class="tips-desc">
          <div class="desc-top">{{
            cType == 'shop_manager'
              ? '抱歉，店长信息更新中..'
              : '抱歉，教练信息更新中..'
          }}</div>
          <div class="desc-bottom"
            >推荐您添加{{
              showType == 'shop_manager'
                ? `${
                    cType == 'shop_manager' ? '第二' : ''
                  }店长，将为您安排所有事宜。`
                : '专属客服，竭诚为您服务。'
            }}</div
          >
        </div>
      </div>
      <div class="cwc-content">
        <img
          class="content-logo"
          src="https://cdnvue.gymcity.com.cn/uploads/pub-caise-logo"
          alt=""
        />
        <img
          class="content-img"
          :src="
            curInfo.app_img + '?x-oss-process=image/resize,m_fill,h_750,w_750'
          "
          alt=""
        />
        <div class="content-desc">
          <div class="desc-info">
            <div class="info-name">{{ curInfo.name }}</div>
            <div class="info-text">{{
              showType == 'kf'
                ? '大事小情都可以联系我哦~'
                : '欢迎添加，随时都可联系哦'
            }}</div>
            <div class="info-line"></div>
            <div class="info-item" v-if="showType == 'kf'">
              <van-icon class="item-icon" name="clock-o" />
              <div class="item-text"> 工作日：9:00-18:00 </div>
            </div>
            <div class="info-item" v-else>
              <van-icon class="item-icon" name="location-o" />
              <div class="item-text"> {{ curInfo.shop_name }} </div>
            </div>
            <div class="info-item" v-if="levelObj[curInfo.level]">
              <van-icon class="item-icon" name="manager-o" />
              <div class="item-text">
                {{ levelObj[curInfo.level] }}
              </div>
            </div>
          </div>
          <img class="desc-qrcode" :src="curInfo.qr_code" alt="" />
        </div>
      </div>
      <div class="cwc-bottom" :class="{ 'cwc-bottom-app': isApp }">{{
        isApp ? '扫描二维码，添加我的企业微信' : '长按二维码，添加我的企业微信'
      }}</div>
    </div>
    <vLoading v-else />
    <!-- v-if="isApp && imgUrl" -->
    <div
      class="cwc-btn user-btn"
      @click="bindToAddWechat"
      v-if="isApp && imgUrl"
      >{{ showAddWechat ? '一键添加企业微信' : '保存到相册' }}</div
    >
  </div>
</template>

<script>
import CardlNavBar from './ponents/CardlNavBar.vue'
import BetterweWxApi from '@/components/wx/control.js'
import { eventObj } from '@/components/app/share/share-method.js' // 分享组件
import html2canvas from 'html2canvas' // 生成图片
export default {
  name: 'coach-wxwork-card',

  components: {
    CardlNavBar
  },

  props: {},

  data() {
    return {
      cType: this.$route.query.cType || '', // 当前教练类型 从门店详情进来是shop_manager 找不到时显示文案不同
      cid: this.$route.query.cid || this.$route.query.coachid || '',
      info: null,
      curInfo: null,
      showType: '',
      navBarOpacity: 0,
      imgUrl: '',
      levelObj: {
        coach: '教练',
        shop_manager: '店长',
        kf: '客服'
      },
      kfObj: {
        cs: {
          app_img: 'https://cdnvue.gymcity.com.cn/uploads/coach-wxwork-kf-cs',
          qr_code:
            'https://cdnvue.gymcity.com.cn/uploads/coach-wxwork-qrcode-cs',
          level: 'kf',
          name: '客服-冰冰',
          link_url: 'https://work.weixin.qq.com/ca/cawcde3317a4eae3c1'
        },
        js: {
          app_img: 'https://cdnvue.gymcity.com.cn/uploads/coach-wxwork-kf-js',
          qr_code:
            'https://cdnvue.gymcity.com.cn/uploads/coach-wxwork-qrcode-js',
          level: 'kf',
          name: '健萌售后'
        }
      }
    }
  },

  computed: {
    qrcodeUrl() {
      // 获取环境变量并设置默认值
      const env = this.$http.getEnv()
      const baseUrlMap = {
        Pro: 'https://vue.gymcity.com.cn/?path=',
        Test: 'https://test.gymcity.com.cn/?path=',
        Default: 'http://vue.gym2.com/?path='
      }
      const baseUrl = baseUrlMap[env] || baseUrlMap.Default
      return `${baseUrl}app-appointment-trans&btwH5Path=coach-wxwork-card&cid=${this.cid}`
    },
    cwcImgUrl() {
      return `cwcImgUrl_${this.cid}`
    },
    isApp() {
      return this.$betterwe.isApp()
    },
    showAddWechat() {
      return this.curInfo.link_url
    }
  },

  watch: {},

  created() {
    this.getInfo()
    this.$http.get('member/index?a=shareLogPush', {
      from: `教练企微名片-曝光`,
      from_id: 25092434
    })
  },

  mounted() {
    this.$refs.parentScroll.addEventListener('scroll', this.bindScroll, {
      passive: false
    })
  },

  beforeDestroy() {
    this.$refs.parentScroll.removeEventListener('scroll', this.bindScroll)
  },
  destroyed() {},

  methods: {
    // 一键拉起添加企微
    bindToAddWechat() {
      if (!this.isApp) {
        return
      }
      if (!this.showAddWechat) {
        this.handleSaveImage()
        return
      }
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练企微名片-点击添加企微`,
        from_id: 25092434
      })
      this.$betterwe.jumpRoute(
        '/web?url=' + encodeURIComponent(this.curInfo.link_url)
      )
    },
    // 保存图片
    handleSaveImage() {
      console.log('保存图片', this.imgUrl)
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练企微名片-保存图片-app`,
        from_id: 25092434
      })
      this.$betterwe.onAppSaveImage({
        data: this.imgUrl,
        type: 'base64'
      })
    },
    // 配置微信H5分享
    setShareOptions() {
      if (this.isApp) return
      let shareOptions = {
        link: this.qrcodeUrl,
        title:
          this.showType == 'kf' ? '点击添加健萌客服' : '点击添加我的企业微信',
        desc:
          this.showType == 'kf'
            ? `你好，健萌的大事小情都可以联系我哦~`
            : `你好，我是${this.curInfo.name}，我在${this.curInfo.shop_name}，一起行动起来吧~`,
        imgUrl:
          this.curInfo.app_img +
          '?x-oss-process=image/resize,m_fill,h_200,w_200'
      }
      BetterweWxApi.setShareData(shareOptions, shareOptions)
    },
    // app分享
    handleShare() {
      this.$http.get('member/index?a=shareLogPush', {
        from: `教练企微名片-点击分享`,
        from_id: 25092434
      })

      const qrcodeUrl = this.qrcodeUrl
      const title =
        this.showType == 'kf' ? '点击添加健萌客服' : '点击添加我的企业微信'
      const desc =
        this.showType == 'kf'
          ? `你好，健萌的大事小情都可以联系我哦~`
          : `你好，我是${this.curInfo.name}，我在${this.curInfo.shop_name}，一起行动起来吧~`
      const thumbnail =
        this.curInfo.app_img + '?x-oss-process=image/resize,m_fill,h_200,w_200'
      const shareOptions = {
        //分享参数
        url: qrcodeUrl,
        title: title,
        desc: desc,
        thumbnail: thumbnail
      }
      eventObj.shareLinkToWxFriend(shareOptions)
    },
    getInfo() {
      this.$http
        .get('member/AppEntrance?a=getCoachQrCode', { cid: this.cid })
        .then((res) => {
          if (res.data.code == 200) {
            this.info = res.data.data
            let curInfo = null
            if (!this.info) return null
            if (this.info.coach?.qr_code && this.info.coach?.link_url) {
              this.showType = 'coach'
              curInfo = this.info.coach
            } else if (
              this.info.shop_manager?.qr_code &&
              this.info.shop_manager?.link_url
            ) {
              this.showType = 'shop_manager'
              curInfo = this.info.shop_manager
            } else {
              this.showType = 'kf'
              curInfo = [3201, 3205].includes(this.info.region_id * 1)
                ? this.kfObj.js
                : this.kfObj.cs
            }
            // 接口下发cdn地址 OSS后台设置了允许跨越
            // 生成图片跨域 替换成代理地址  测试 正式生效 本地不生效
            // curInfo.app_img = curInfo.app_img
            //   .replace(
            //     'https://wegymer-vue.oss-cn-beijing.aliyuncs.com',
            //     `${location.origin}/vue_image`
            //   )
            //   .replace(
            //     'https://wegymercdn.gymcity.com.cn',
            //     `${location.origin}/coach_image`
            //   )
            this.curInfo = curInfo
            // 配置微信H5分享
            this.setShareOptions()
            // 生成图片
            this.getImg()
          }
        })
    },
    // 监听页面滑动 控制nav不透明度
    bindScroll(e) {
      let el = e.target
      let minHeight = 50
      let maxHeight = 150
      var scroll = Math.round(e.target.scrollTop)

      if (scroll < minHeight) {
        this.navBarOpacity = 0
      } else if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        let pecent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = parseFloat(pecent.toFixed(2))
      }
    },
    // 生成图片
    getImg() {
      if (sessionStorage.getItem(this.cwcImgUrl)) {
        this.imgUrl = sessionStorage.getItem(this.cwcImgUrl)
        return
      }
      const that = this
      setTimeout(() => {
        that.$nextTick(() => {
          html2canvas(that.$refs.cwcContainer, {
            backgroundColor: null,
            useCORS: true,
            scrollX: 0,
            scrollY: 0
          })
            .then(function (canvas) {
              that.imgUrl = canvas.toDataURL()
              sessionStorage.setItem(that.cwcImgUrl, that.imgUrl)
            })
            .catch((err) => {
              console.log('html2canvas err', err)
              // that.$toast.clear()
              // that.$toast.fail('加载失败')
            })
        })
      }, 100)
    },
    getBottomContentHeight(height) {
      this.navBarContentHeight = height
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.coach-wxwork-card {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: vw(10);
  padding-bottom: calc(#{vw(10)} + constant(safe-area-inset-bottom));
  padding-bottom: calc(#{vw(10)} + env(safe-area-inset-bottom));
  .cwc-bg {
    width: 100%;
    box-sizing: border-box;
    // position: absolute;
    // top: 0;
    // left: 0;
    z-index: 1;
  }
  .cwc-container {
    width: 100%;
    box-sizing: border-box;
    background-color: #f7f7f7;
    padding: vw(20);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .cwc-tips {
      width: 100%;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: vw(8);
      padding: vw(14);
      display: flex;
      align-items: center;
      margin-bottom: vw(10);
      .tips-icon {
        font-size: vw(26);
        color: #ff2270;
        margin-right: vw(14);
      }
      .tips-desc {
        .desc-top {
          font-weight: 500;
          font-size: vw(13);
          color: #050b27;
          line-height: vw(18);
        }
        .desc-bottom {
          font-weight: 400;
          font-size: vw(12);
          color: #050b27;
          line-height: vw(15);
          margin-top: vw(3);
        }
      }
    }
    .cwc-content {
      width: 100%;
      box-sizing: border-box;
      padding: vw(12);
      background: #ffffff;
      border-radius: vw(4);
      .content-logo {
        width: vw(112);
        margin-left: auto;
      }
      .content-img {
        width: vw(311);
        height: vw(311);
        box-sizing: border-box;
        object-fit: cover;
        margin-top: vw(13);
      }
      .content-desc {
        margin-top: vw(36);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .desc-info {
          .info-name {
            max-width: vw(182);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 600;
            font-size: 24px;
            color: #050b27;
            line-height: 33px;
          }
          .info-text {
            font-weight: 500;
            font-size: 13px;
            color: #050b27;
            line-height: 18px;
            margin-top: vw(2);
          }
          .info-line {
            width: 100%;
            height: vw(1);
            background-color: rgba(#050b27, 0.16);
            margin: vw(10) 0;
          }
          .info-item {
            display: flex;
            align-items: baseline;
            font-weight: 400;
            font-size: vw(12);
            color: rgba(#050b27, 0.7);
            &:not(:last-child) {
              margin-bottom: vw(3);
            }
            .item-icon {
              // font-size: vw(10);
              margin-right: vw(6);
            }
          }
        }
        .desc-qrcode {
          width: vw(103);
          height: vw(103);
          box-sizing: border-box;
          object-fit: cover;
          margin-left: vw(12);
        }
      }
    }
    .cwc-bottom {
      font-weight: 400;
      font-size: vw(16);
      color: rgba(#050b27, 0.3);
      line-height: vw(17);
      text-align: center;
      margin-top: vw(20);
    }
    .cwc-bottom-app {
      font-size: vw(12);
    }
  }
  .cwc-btn {
    width: vw(335);
    height: vw(44);
    box-sizing: border-box;
    background: #ff2270;
    border-radius: vw(24);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: vw(16);
    color: #ffffff;
    // margin-top: vw(23);
  }
}
</style>
